import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';

/**
 * Catch-all page for URLs that match no route.
 *
 * Before this existed, an unknown URL (a typo, an old link, a deleted slug)
 * rendered absolutely nothing: a blank white page. Search engines treat that as
 * a soft 404, and visitors just bounce. This renders a real page, marked
 * noindex so it can never be indexed itself.
 */
const NotFoundPage: React.FC = () => {
  const wrap: React.CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    textAlign: 'center',
    background: '#fff'
  };

  const title: React.CSSProperties = {
    fontSize: 'clamp(28px, 5vw, 40px)',
    fontWeight: 800,
    margin: '0 0 12px',
    color: '#111827'
  };

  const text: React.CSSProperties = {
    fontSize: '17px',
    color: '#4b5563',
    margin: '0 0 26px',
    maxWidth: '520px'
  };

  const linkStyle: React.CSSProperties = {
    display: 'inline-block',
    margin: '0 6px 10px',
    padding: '12px 22px',
    borderRadius: '9px',
    fontWeight: 700,
    textDecoration: 'none'
  };

  return (
    <>
      <SEO
        title="Page not found | PokeShani"
        description="The page you were looking for could not be found on PokeShani."
        url="https://pokeshani.com/404"
        robots="noindex, follow"
      />

      <div style={wrap}>
        <div>
          <h1 style={title}>Page not found</h1>
          <p style={text}>
            The page you were looking for does not exist, or the product may have
            been removed by its creator. Here are some places that do work.
          </p>
          <div>
            <Link
              to="/marketplace"
              style={{ ...linkStyle, background: '#0f9d58', color: '#fff' }}
            >
              Browse the marketplace
            </Link>
            <Link
              to="/"
              style={{
                ...linkStyle,
                background: '#f3f4f6',
                color: '#111827'
              }}
            >
              Go to the homepage
            </Link>
            <Link
              to="/faq"
              style={{
                ...linkStyle,
                background: '#f3f4f6',
                color: '#111827'
              }}
            >
              Help &amp; FAQ
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;